class StepCompletionStore extends require("lib/static-shim").default(
  require("lib/core/store/backbone-store").default
) {
  static initClass() {
    // Stores state and actions for step completion (grading, feedback, etc...)

    this.prototype.defaults = {}

    this.prototype.resources = {
      assessment_for_review: {
        model: require("assessments/models/assessment-for-user").default,
        cache: false
      }
    }

    this.prototype.actions = {
      loadAssessmentForReview(step_id, content_id, user_id) {
        const params = {
          id: content_id,
          stepID: step_id,
          userID: user_id,
          isReview: true
        }
        return this.resource.assessment_for_review.load(params)
      }
    }

    this.prototype.requests = {}
  }
}
StepCompletionStore.initClass()

export default window.App.stores.registerStore(
  "stepCompletion",
  StepCompletionStore
)

function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null
    ? transform(value)
    : undefined
}
